module.exports = __webpack_public_path__ + "img/mind_template_item_4_3.9af7bf88.png";